import React from 'react'

import { BLACK_COLOR } from '../../utils/constants'

const FilterIcon = () => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 6C9 6.82843 9.67157 7.5 10.5 7.5C11.3284 7.5 12 6.82843 12 6C12 5.17157 11.3284 4.5 10.5 4.5C9.67157 4.5 9 5.17157 9 6ZM10 6C10 6.27614 10.2239 6.5 10.5 6.5C10.7761 6.5 11 6.27614 11 6C11 5.72386 10.7761 5.5 10.5 5.5C10.2239 5.5 10 5.72386 10 6Z"
      fill={BLACK_COLOR}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 11C4 11.8284 4.67157 12.5 5.5 12.5C6.32843 12.5 7 11.8284 7 11C7 10.1716 6.32843 9.5 5.5 9.5C4.67157 9.5 4 10.1716 4 11ZM5 11C5 11.2761 5.22386 11.5 5.5 11.5C5.77614 11.5 6 11.2761 6 11C6 10.7239 5.77614 10.5 5.5 10.5C5.22386 10.5 5 10.7239 5 11Z"
      fill={BLACK_COLOR}
    />
    <rect
      x="5"
      y="5.5"
      width="5"
      height="1"
      rx="0.5"
      fill={BLACK_COLOR}
    />
    <rect
      x="6"
      y="10.5"
      width="5"
      height="1"
      rx="0.5"
      fill={BLACK_COLOR}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 16.5H14C15.1046 16.5 16 15.6046 16 14.5V2.5C16 1.39543 15.1046 0.5 14 0.5H2C0.89543 0.5 0 1.39543 0 2.5V14.5C0 15.6046 0.89543 16.5 2 16.5ZM15 14.5C15 15.0523 14.5523 15.5 14 15.5H2C1.44772 15.5 1 15.0523 1 14.5V2.5C1 1.94772 1.44772 1.5 2 1.5H14C14.5523 1.5 15 1.94772 15 2.5V14.5Z"
      fill={BLACK_COLOR}
    />
  </svg>
)

export default FilterIcon
